<template>
  <div class="serve-info">
    <div class="tools-box">
      <!-- obj.payType == 2 月交 -->
      <div class="tabs" v-if="obj.payType == 2">
        <div
          class="tab"
          @click="changeYear(index, item)"
          v-for="(item, index) in obj.commissionYearNum"
          :key="index"
          :class="{ 'active': index == tabsYearActiveIndex }"
        >
          第{{ $units.numberTransform(item) }}年
        </div>
      </div>
      <Tooltip transfer content="如果发现服务费异常或缺失，您可以根据异常原因修复后点击重新生成">
        <Button type="primary" :loading="pageLoading" @click="generateCommission">重新生成费用</Button>
      </Tooltip>
      <Button type="primary" class="add-commission-items" @click="$refs.modifyCommissionRef.open(obj)" v-if="userInfo.levelCode=='10001'&&$units.pointAction('order_30_17')">新增/扣减费用项</Button>
    </div>
    
    <div v-if="list.length == 0" style="text-align: center; color: red; padding-top: 20px">
      <span v-if="obj.noCommissionReason">{{ obj.noCommissionReason }}</span>
      <span v-else-if="type == 'isAbnormal'">参数异常，无法计算服务费</span>
      <noData v-else class="null-box"></noData>
    </div>
    <div class="fee-table" v-if="list.length">
      <div class="head" :class="{ 'hasTab': obj.payType == 2 }">
        <div class="td td1">期数</div>
        <div class="td td2">服务费归属</div>
        <div class="td td3">归属人类型</div>
        <div class="td td4">产品/险种名称</div>
        <div class="td td5">保费（元）</div>
        <div class="td td6" v-if="showFold">折标系数</div>
        <div class="td td7">基础发放</div>
        <div class="td td11" v-if="obj.isActivityRate">限时活动加费</div>
        <div class="td td8" v-if="obj.isDynamicRate">基础后置比例</div>
        <div class="td td9">
          <span>收入（元）</span>
          <Tooltip transfer content="包含基础和活动">
            <i class="tip-icon">?</i>
          </Tooltip>
        </div>
        <div class="td td10">
          <span>剩余收入（元）</span>
          <Tooltip transfer content="仅包含基础和平台活动，减掉下级收入后的剩余收入">
            <i class="tip-icon">?</i>
          </Tooltip>
        </div>
      </div>
      <div class="body">
        <div class="row-child" v-for="(item, i) in list" :key="i">
          <div class="td td1">
            {{ item.commissionNum == 1 ? '首期' : `第${$units.numberTransform(item.commissionNum)}期` }}
          </div>
          <div class="row-box">
            <div class="row-child" v-for="(item2, ii) in item.commissionInfoList" :key="ii">
              <!-- 出单归属异常 -->
              <div class="row-box" v-if="!item2.owerName">
                <div class="error-box">出单归属参数缺失，无法计算业务员费用</div>
              </div>
              <template v-else>
                <!-- 服务费归属 -->
                <div class="td td2">{{ item2.owerName }}</div>
                <!-- 归属人类型 -->
                <div class="td td3">{{ item2.owerType }}</div>
                <div class="row-box" :class="{ 'hide-child': item2.hidden }">
                  <div class="row-child" v-for="(item3, iii) in item2.policyInfoList" :key="iii" :class="{ 'hide-flag': iii > 0 }">
                    <div class="td td4">{{ item3.productName }}</div>
                    <!-- 保费异常 -->
                    <div class="row-box" v-if="item3.fee == null">
                      <div class="error-box">保费缺失，无法计算费用</div>
                    </div>
                    <template v-else>
                      <div class="td td5 td-column">
                        <span class="value-td">{{ item3.fee }}</span>
                        <p v-if="item3.deductResidualIncome * 1 || item3.totalDeductIncome * 1" class="deduct-td deduct">{{ item3.deductFee }}
                          <span class="deduct-tag">退费</span>
                        </p>
                      </div>
                      <!-- 折标 -->
                      <div class="td td6 td-column" v-if="showFold">
                        <span class="value-td">{{ !item3.fold ? '--' : item3.fold + '%' }}</span>
                        <p v-if="item3.deductResidualIncome * 1 || item3.totalDeductIncome * 1" class="deduct-td">--</p>
                      </div>

                      <!-- 费用异常 -->
                      <!-- 存在附加险时第一行是合计不判断，不存在附加险时都判断 -->
                      <div class="row-box" v-if="item3.noCommissionReason">
                        <div class="error-box">{{item3.noCommissionReason}}</div>
                      </div>                      
                      <template v-else>
                        <!-- 基础发放 -->
                        <div class="td td7 td-column">
                          <div class="value-td">
                            <span v-for="(itemCommission, indexCommission) in item3.commission" :key="indexCommission">
                              <span v-if="item3.commission && item3.commission.length>1 && (item3.commission[1] >= 0) && indexCommission !=0">+</span>
                              {{ itemCommission || itemCommission === 0 ? Number(itemCommission).mul(100) + '%' : '' }}
                            </span>
                            <!-- <span v-if="item3.rewardRate" style="color: orange">+{{ item3.rewardRate + '%' }}</span> -->
                            <span v-if="!item3.commission || item3.commission && !item3.commission.length">--</span>
                          </div>
                          <p v-if="item3.deductResidualIncome * 1 || item3.totalDeductIncome * 1" class="deduct-td">{{ item3.deductIncome || '--' }}</p>
                          <!-- 补结费用 -->
                          <!-- <span v-if="item3.repairCommission && item3.repairCommission != '0'">
                            {{ item3.repairCommission ? `${item3.repairCommission > 0 ? '+' : ''}${item3.repairCommission}%` : '' }}
                          </span>
                          <div style="display: inline-block" v-if="item3.merchantActivity">
                            <span style="color: orange">+{{ item3.merchantActivity.rewardRate + '%' }}</span>
                            <Tooltip>
                              <Icon type="ios-help-circle" size="16" />
                              <template #content>
                                <p>
                                  活动时间：{{ item3.merchantActivity.startTime | filterTime('YYYY/MM/DD') }}-{{
                                    item3.merchantActivity.endTime | filterTime('YYYY/MM/DD')
                                  }}
                                </p>
                                <p>活动名称：{{ item3.merchantActivity.name }}</p>
                              </template>
                            </Tooltip>
                          </div> -->
                        </div>
                        <!-- 限时活动加费 -->
                        <div class="td td11 td-column" v-if="obj.isActivityRate">
                          <div class="value-td">
                            <span v-for="(itemAct, actIndex) in item3.activityCommission" :key="actIndex" :class="{'deduct-act-name':itemAct!=0 && itemAct!=0.00}">
                              <span v-if="item3.activityCommission && item3.activityCommission.length>1 && item3.activityCommission[1] >= 0 && actIndex !=0">+</span>
                              <span>{{ itemAct!=0 && itemAct!=0.00 ? Number(itemAct).mul(100) + '%' :'--' }}</span>
                            </span>
                            <span v-if="!item3.activityCommission || !item3.activityCommission.length">--</span>
                          </div>
                          <p v-if="item3.deductResidualIncome * 1 || item3.totalDeductIncome * 1" class="deduct-td" :class="{'deduct-act-name':item3.deductActivityIncome && item3.deductActivityIncome != '0'}">{{ item3.deductActivityIncome && item3.deductActivityIncome != '0' ? item3.deductActivityIncome : '--' }}</p>
                        </div>
                        
                        <!-- 费用后置比例 -->
                        <div class="td td8 td-column" v-if="obj.isDynamicRate">
                          <div class="value-td">
                            <span v-for="(itemPost, postIndex) in item3.postfRate" :key="postIndex">
                              <span v-if="item3.postfRate && item3.postfRate.length>1 && item3.postfRate[1] >= 0 && postIndex !=0">+</span>
                              {{ Number(itemPost).mul(100) + '%' }}
                            </span>
                            <span v-if="!item3.postfRate || item3.postfRate && !item3.postfRate.length">--</span>
                          </div>
                          <p v-if="item3.deductResidualIncome * 1 || item3.totalDeductIncome * 1" class="deduct-td">{{ item3.deductPostfIncome || '--' }}</p>
                        </div>
                        <!-- 收入（元） -->
                        <div class="td td9 td-column">
                          <span class="value-td">{{ item3.totalIncome | filterIncome(item3)}}</span>
                          <p v-if="item3.deductResidualIncome * 1 || item3.totalDeductIncome * 1" class="deduct-td deduct">
                            <span>{{ item3.totalDeductIncome }}</span>
                            <span class="deduct-tag" v-if="item2.owerType == '商户' || item2.owerType == '业务员'">扣款</span>
                          </p>
                        </div>
                        <!-- 剩余收入（元） -->
                        <div class="td td10 td-column">
                          <span class="value-td">
                            {{ item3.residualIncome  | filterIncome(item3) }}
                            <Icon
                              size="20"
                              :type="item2.hidden ? 'md-arrow-dropdown' : 'md-arrow-dropup'"
                              @click="toggleTable(item2)"
                              v-show="iii == 0 && item2.policyInfoList.length > 1"
                            />
                          </span>
                          <p v-if="item3.deductResidualIncome * 1 || item3.totalDeductIncome * 1" class="deduct-td deduct">
                            <span>{{ item3.deductResidualIncome}}</span>
                            <span class="deduct-tag" v-if="item2.owerType.includes('机构')">扣款</span>
                          </p>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>

    <!-- 新增/扣减费用项 -->
    <modifyCommissionModal ref="modifyCommissionRef" @success="$emit('reload')"></modifyCommissionModal>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import modifyCommissionModal from './modifyCommissionModal';
import { mapState } from "vuex";

export default {
  components: { confirmModal, modifyCommissionModal },
  props: {
    obj: null, // 保单详情
    type: null, // isAbnormal 异常单
  },
  data() {
    return {
      pageLoading: false,
      tabsYearActiveIndex: 0 // 当前年限index
    };
  },
  filters:{
    filterIncome(val,item){
      if(item.totalIncome || item.residualIncome || item.noCommissionReason){
        return val
      }else{
        return '--'
      }
    }
  },
  computed: {
    ...mapState(["userInfo"]),
    // 是否显示折标系数
    showFold() {
      const obj = this.obj;
      return obj.sourceType == 2 || obj.sourceType == 1 || !obj.sourceType;
    },
    list() {
      const obj = this.obj;
      console.log('obj', obj, obj.commissionInfoVOList);
      if (
        !obj ||
        !obj.commissionInfoVOList ||
        obj.commissionInfoVOList.length == 0 ||
        !obj.commissionInfoVOList[0].commissionInfoList ||
        obj.commissionInfoVOList[0].commissionInfoList.length == 0
      ) {
        return [];
      }
      // 月交
      if (obj.payType == 2) {
        return obj.commissionInfoVOList.filter(item => item.commissionIndex == this.tabsYearActiveIndex + 1);
      } else {
        return obj.commissionInfoVOList;
      }
    }
  },

  watch: {},
  created() {},
  methods: {
    changeYear(index) {
      this.tabsYearActiveIndex = index;
    },
    // 切换表格子内容显示
    toggleTable(item) {
      this.$set(item, 'hidden', !item.hidden);
    },
    // 生成费用
    generateCommission() {
      if(!this.$units.pointAction('order_30_16')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.generateCommissionAjax(1).then(() => {
        this.$refs.confirmModal
          .open({
            title: '提示',
            content: '请确认是否重新生成费用？相关未对账或未结算数据会同步更新'
          })
          .then(() => {
            this.generateCommissionAjax(0).then(() => {
              this.$notice.success('生成费用成功');
            });
          });
      });
    },
    // 生成费用请求 isOnlyCheck 是否仅验证
    generateCommissionAjax(isOnlyCheck) {
      this.pageLoading = true;
      return this.$http({
        url: `/buz/policy/matchCommissionAgain`,
        type: 'GET',
        data: {
          policyNo: this.obj.policyNo,
          isOnlyCheck: isOnlyCheck
        }
      }).finally(() => {
        this.pageLoading = false;
        if(!isOnlyCheck) {
          this.$emit('reload');
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './serveInfoNew.scss';
</style>
